import { Grid } from '@mui/material'
import React, { PropsWithChildren } from 'react'

const GridContainer = ({ children }: PropsWithChildren) => {
  return (
    <Grid
      container
      alignContent={'flex-start'}
      sx={{
        width: 'calc(100% + 1rem)',
        height: 'auto',
        ml: -1,
        paddingBottom: 2,
      }}
    >
      {children}
    </Grid>
  )
}

export default GridContainer
